/**
 * Who may add, switch off or delete a lead source (Leads → Sources).
 * 2026-10-07 (Manak): only admin / owner / super_admin — the same set the backend
 * enforces (backend/src/modules/crm/lead-sources.routes.ts LEAD_SOURCE_ADMIN_ROLES).
 */
export const LEAD_SOURCE_ADMIN_ROLES: ReadonlySet<string> = new Set(['admin', 'owner', 'super_admin']);

export function canManageLeadSources(roleName: string | null | undefined): boolean {
  return LEAD_SOURCE_ADMIN_ROLES.has((roleName ?? '').trim().toLowerCase().replace(/[ -]+/g, '_'));
}
